import React from 'react';
import { Link } from 'react-router-dom';
import styles from './PageHeader.module.css';

const PageHeader = ({
  title,
  subtitle,
  backTo,
  backText,
  actions,
  badge,
  className = ''
}) => {
  return (
    <div className={`${styles.headerWrapper} ${className}`.trim()}>
      {backTo && (
        <Link to={backTo} className={styles.backLink}>
          {backText || '← Back'}
        </Link>
      )}
      <div className={styles.contentRow}>
        <div className={styles.titleArea}>
          <div className={styles.titleRow}>
            <h1 className={styles.title}>{title}</h1>
            {badge && <div>{badge}</div>}
          </div>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
    </div>
  );
};

export default PageHeader;
